import styled from 'styled-components';

const TitleAnimStyle = styled.div`
	width: fit-content;
	height: fit-content;
	position: relative;

	svg {
		position: absolute;
		top: 0;
		left: 0;
		overflow: visible !important;
	}

	.wrapper-styling-block {
		opacity: 0;
	}
`;
export default TitleAnimStyle;
